import axios from "axios";

const fetchBillVotesDetails = async (billId) => {
    try {
        const [executiveActionResponse, floorVoteResponse] = await Promise.all([
            axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/committees/v1/executiveActions/findByBillId?billId=${billId}`),
            axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/bills/v1/votes/findByBillId?billId=${billId}`),
        ]);

        return {
            executiveActionData: executiveActionResponse.data,
            floorVoteData: floorVoteResponse.data,
        };
    } catch (error) {
        console.error("Error fetching bill vote details:", error);
        throw error;
    }
};

export default fetchBillVotesDetails;